import React from 'react';
import { Button } from 'components';
import { sizes } from 'assets';
import styles from './TableHeader.module.scss';
import { BrandsTableState } from '../BrandsTable';

interface Props extends BrandsTableState {
  setState: (obj: object) => void;
}

const TableHeader = (props: Props) => {
  const { arrangeByName, arrangeByAddedDate, arrangeOrder, setState } = props;

  return (
    <div className={styles.tableHeader}>
      <Button
        className={styles.tableHeaderBttn}
        style={{ width: sizes.brandsTableNameWidth }}
        onClick={() => setState(s => ({
          ...s,
          arrangeByName: arrangeByName === 'ascending' ? 'descending' : 'ascending',
          arrangeOrder: ['name', [...arrangeOrder].filter(value => value !== 'name')]
        }))}
      >
        {`name ${arrangeByName === 'ascending' ? '▼' : '▲'}`}
      </Button>

      <Button
        className={styles.tableHeaderBttn}
        style={{ width: sizes.projectsTableAddedAtWidth }}
        onClick={() => setState(s => ({
          ...s,
          arrangeByAddedDate: arrangeByAddedDate === 'ascending' ? 'descending' : 'ascending',
          arrangeOrder: ['date', [...arrangeOrder].filter(value => value !== 'date')]
        }))}
      >
        {`added at ${arrangeByAddedDate === 'ascending' ? '▼' : '▲'}`}
      </Button>

      <Button
        className={[styles.tableHeaderBttn, styles.inactiveBttn].join(' ')}
        style={{ width: sizes.projectsTableTagsWidth }}
      >
        tags
      </Button>

      <Button
        className={[styles.tableHeaderBttn, styles.inactiveBttn].join(' ')}
        style={{ flex: 1 }}
      >
        products
      </Button>
    </div>
  );
};

export default TableHeader;
